// gfb APIs
export const LOGIN = '/login';
export const LOGOUT = '/logout';
export const GRAB_ID_LOGOUT = '/oauth2/logout';
export const EMPLOYEES = '/employees';
export const FETCH_USER_INFO = '/user';
export const FETCH_CITY = '/cities';
export const FORGOT_PASSWORD = '/password_reset_request';
// TODO: enterprise-api APIs to be deprecated
export const FETCH_PORTAL_USER_PROFILES = '/user';
export const ATHORIZATION_ACTIONS = '/authorisation/actions';

// ge APIs
export const CREATE_ORDER = '/deliveries';
export const CANCEL_ORDER = '/deliveries/{delivery_id}';
export const FETCH_DELIVERY = '/deliveries';
export const FETCH_QUOTE = '/deliveries/quotes';
export const FETCH_ADDRESS_TRANSLATE = '/address/reverse';
export const FETCH_ADDRESS_SEARCH = '/address/search';
export const FETCH_SERVICE_TYPE = '/getServicesAndPools';
export const FETCH_PAYMENT = '/payments';
export const LINK_COMPANY = '/register/link';
export const GET_COMPANY_PERMISSIONS = '/company/permissions';
export const GET_COMPANY_USER_PROFILES = '/company/userprofiles';
export const FETCH_CANCEL_REASONS = '/feedback/cancel';
export const SEND_FEEDBACK_REASONS = '/feedback/cancel';
export const GET_USER_CONFIGURATION = '/configuration';
export const GET_LKPP_TOKEN = '/exchange-token/lkpp';
export const PAX_FETCH_BUSINESS_PROFILES = '/pax/businessProfiles';

// ge API V2
export const ONGOING_DELIVERIES = '/ongoing-deliveries';
export const HISTORY_DELIVERIES = '/history-deliveries';
export const PAX_FETCH_SERVICE_TYPE = '/pax/getServicesAndPools';
export const PAX_FETCH_PAYMENT_METHODS = '/pax/paymentMethods';
export const PAX_FETCH_SEARCH_ADDRESS = '/pax/address/search';
export const PAX_FETCH_ADDRESS_TRANSLATE = '/pax/address/reverse';
export const PAX_FETCH_HISTORY_DELIVERIES = '/pax/historyDeliveries';
export const FETCH_FAILED_PAYMENTS_LIST = '/failed-payments';
export const PAX_CANCEL_DELIVERY = '/pax/deliveries';
export const PAX_FETCH_ONGOING_DELIVERIES = '/pax/ongoingDeliveries';
export const RETRY_FAILED_PAYMENTS = '/failed-payments/retry';
export const PAX_FETCH_USER_CONFIGURATION = '/pax/configuration';

// ge shopify APIs
export const SHOPIFY_INIT_CONNECTION = '/shopify/connection/init';
export const SHOPIFY_COMPLETE_CONNECTION = '/shopify/connection/complete';
export const SHOPIFY_GET_CONNECTIONS = '/shopify/connections';
export const SHOPIFY_UPDATE_CONFIGURATION_BASIC =
  '/shopify/configuration/basic';
export const SHOPIFY_UPDATE_CONFIGURATION_PICKUP_ADDRESS =
  '/shopify/configuration/pickupaddress';
export const SHOPIFY_UPDATE_CONFIGURATION_FINANCIAL_STATUS =
  '/shopify/configuration/financialstatus';
export const SHOPIFY_GET_ORDERS = '/shopify/orders';
export const SHOPIFY_GET_DELIVERIES_QUOTES = '/shopify/deliveries/quotes';
export const SHOPIFY_CREATE_DELIVERIES = '/shopify/orders/deliveries';
